import React from 'react';
import { Navigate } from 'react-router-dom';

// Register is handled in Landing page
const Register = () => {
  return <Navigate to="/?register" replace />;
};

export default Register;

